<template>
  <b-modal
    id="stripe-payments"
    title="Make your payment with Payoo & Stripe"
    header-bg-variant="dark"
    header-text-variant="light"
    body-bg-variant="light"
    body-text-variant="dark"
    footer-bg-variant="light"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    visible
    >
    <b-row><b-col>Enter your card details</b-col></b-row>
    <b-form id="payment-form">
      <b-row cols="1">
        <b-col><b-form-input v-model="card_name" class="sb-input" placeholder="Name on card"></b-form-input></b-col>
      </b-row>
      <div class="mt-2 sb-input form-control" id="card-element">
      </div>
      <div id="card-errors" role="alert"></div>
      <b-row class="mt-2 sb-info">
        <b-col><span style="float:left;">Subtotal: {{ order_subtotal | toCurrency }}</span></b-col>
        <b-col><span style="float:right;">Order Total: {{ order_total | toCurrency }}</span></b-col>
      </b-row>
      <!-- <b-row>
        <b-col><p style="color: red; text-align: center;">Transaction Fee of $0.50 added to the order</p></b-col>
      </b-row> -->
      <!-- <b-row class="mt-2 sb-info">
        <b-col v-if="order_type==1">Estimated time of delivery {{ deliveryTime.format('h:mma') }}</b-col>
        <b-col v-else>Estimated ready time {{ pickupTime }}</b-col>
      </b-row> -->
    </b-form>
    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="dark" :disabled="pay_spinner" @click="cancel(); stopStripePay()">Back</b-button>
      <!-- <b-button v-if="pay_spinner==false" variant="dark" id="submit" type="submit" @click="confirmPayment()">SUBMIT</b-button> -->
      <b-button v-if="pay_spinner==false" variant="dark" id="submit" type="submit" @click="validatePickupTimes()">SUBMIT</b-button>
      <b-button v-if="pay_spinner==true" variant="dark" disabled ><b-spinner small type="grow"></b-spinner>Wait...</b-button>
    </template>
  </b-modal>
</template>

<script>
// import axios from 'axios';
import moment from 'moment';

export default {
  name: 'StripePayment',
  props: [
    'pickupTime',
    'selectedMenuDate',
    'defaultLocation',
    'payment_intent',
    'order_type',
    'order_subtotal',
    'order_total'
  ],
  data() {
    return {
      stripe: '',
      elements: '',
      card: '',
      style: {
        base: {
          color: "#fff",
        }
      },
      card_name: '',
      intentToken: '',
      pay_spinner: false,
      timeslots: [],
      verifiedPickupTime: this.pickupTime
    }
  },

  computed: {
    formattedTimeSlot: function() {
      if (this.timeslots.length > 0) {
        return moment(this.timeslots[this.timeslotIndex]).format('h:mm A');
      } else {
        return '';
      }
    },

    deliveryTime: function() {
      return moment(this.selectedMenuDate+'T'+this.pickupTime).add(this.selectedLocation.delivery_time, 'minutes');
    },

  },

  methods: {
    emitError(error, severity, stage) {
        this.$emit('emit-error', error, severity, stage);
    },

    /*
    Configures Stripe by setting up the elements and
    creating the card element.
    */
    async configureStripe(){
      // TRY window.Stripe if doesn't work like this
      try {
        this.stripe = await window.Stripe( this.payment_intent.publishableKey, {
            stripeAccount: this.payment_intent.accountNumber
          });

          this.elements = this.stripe.elements();
          this.card = this.elements.create('card', {style: this.style});
          this.emitRemoveOverlay();

          this.card.mount('#card-element');
      } catch (error) {
        this.emitError(error.stack, 5, 'Unable to configure Stripe');
      }
    },

    updateOrder(orderstatus, pickup_time='') {
      // "payoo_public_secret": process.env.VUE_APP_PAYOO_PUBLIC_SECRET,
      var data = {
          "order_status": orderstatus
      }
      if (pickup_time != '') {
        data["pickup_time"]=pickup_time;
      }
      this.$api.patch('/weborder/'+this.payment_intent.order_id+'/status', data)
        .then( function( response ){
          // log order details and secret
          if (response.data.updated == true) {
            return true;
          }
        }.bind(this))
        .catch(e => {
          this.emitError(e.stack, 5, 'update Order Status error');
        })
    },

    validatePickupTimes() {
      // add spinner on payment modal
      this.pay_spinner=true;
      this.updateOrder(2);
      this.confirmPayment();
      // // retrieve available Pickup Times
      // this.$api.get('locations/'+this.selectedLocation.id+'/pickuptimes?date='+this.selectedMenuDate)
      //   .then(response => {
      //    // JSON responses are automatically parsed.
      //    this.timeslots = response.data.time_slots
      //    // if there are no available time slots add the closing time to available timeslots
      //    if (this.timeslots.length == 0) {
      //      this.timeslots.push(this.closing_time.format('YYYY-MM-DD HH:mm:ss'));
      //    }
      //
      //    // establish if the selected timeslot is still available
      //    if (this.timeslots.indexOf(moment(this.selectedMenuDate + 'T' + this.pickupTime).format('YYYY-MM-DD HH:mm:ss')) != -1) {
      //      // there is a match, update order status = 2 and confirm payment
      //      this.updateOrder(2);
      //      this.confirmPayment();
      //    } else {
      //      // timeslot no longer available, if not appt, set this.verifiedPickupTime, update order with next available timeslot, then confirm payment
      //      if (this.order_type!=5) {
      //        this.verifiedPickupTime = moment(this.timeslots[0]).format('HH:mm:ss');
      //        this.updateOrder(2, this.timeslots[0]);
      //        this.confirmPayment();
      //      } else {
      //        // it's an appt, use the timeslotIndex to suggest another time, and update order status to 2 to reserve slot
      //        this.updateOrder(2, this.timeslots[this.timeslotIndex]);
      //        this.verifiedPickupTime = moment(this.timeslots[this.timeslotIndex]).format('HH:mm:ss');
      //        this.$bvModal.msgBoxConfirm('Your selected pickup time is no longer available, the next closest timeslot is ' + this.formattedTimeSlot + '. Would you like this one instead?', {
      //          title: 'Pickup time no longer available',
      //          centered: true,
      //          okTitle: 'Yes',
      //          cancelTitle: 'No'
      //        })
      //        .then(value => {
      //          if (value==true) {
      //            // if they like the new time, set this.verifiedPickupTime and confirm payment
      //            this.confirmPayment();
      //          } else {
      //            // suggested time no good, update order status to 1 and return them to order
      //            this.updateOrder(1);
      //            this.stopStripePay();
      //          }
      //        })
      //        .catch(err => {
      //          console.log(JSON.stringify(err.stack));
      //        })
      //      }
      //    }
      //   })
      //   .catch(e => {
      //    this.emitError(e.stack, 5, 'retrieve pickup times error');
      //   })
    },

    // Direct request to Stripe to confirm card payment
    confirmPayment() {
      // use clientSecret to confirm the card payment info with Stripe
      var clientSecret = this.payment_intent.clientSecret;
      this.stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: this.card,
          billing_details: {
            name: this.card_name
          }
        }
      })
      .then(function(result) {
        if (typeof(result.error)!="undefined") {
          if (result.error.code=="incomplete_zip") {
           this.$bvModal.msgBoxOk('Please check your zip code and try again', {
             title: 'Zip Code incomplete',
             centered: true
           })
           // remove spinner and re-enable buttons
           this.pay_spinner=false;
         } else {
           this.$bvModal.msgBoxOk('Something went wrong with the payment.', {
             title: 'Error making payment',
             centered: true
           })
           // remove spinner and re-enable buttons
           this.pay_spinner=false;
           this.emitError(result.error, 3, 'Payment Failed at Card Details Form');
         }
        } else {
          // The payment has been processed!
          this.validateOrder(this.payment_intent.clientSecret);
        }
      }.bind(this));
    },

    // Message back from retrievePaymentIntent showing paymentIntent exists but status is not succeeded
    validateOrder(clientSecret) {
      this.stripe.retrievePaymentIntent(clientSecret)
      .then(function(result) {
        var paymentIntent = result.paymentIntent;
        if (paymentIntent.status=='succeeded') {
          // trigger the payment success modal - pass the new pickupTime
          this.$emit('paymentstatus', this.verifiedPickupTime);
        } else {
          // display error modal message if issue with payment method
          this.$bvModal.msgBoxOk('Something went wrong verifying the payment.', {
            title: 'Error making payment',
            centered: true
          })
          // remove spinner and re-enable buttons
          this.pay_spinner=false;
          this.emitError(result.error, 3, 'Unable to validate payment');
        }
      }.bind(this));
    },

    stopStripePay() {
      this.$emit('stop-stripe-pay');
    },

    emitRemoveOverlay() {
      this.$emit('sidebaroverlay', false);
    }

  },

  mounted() {
    this.$bvModal.show("stripe-payments");
    this.configureStripe();
  },
}
</script>

<style>

.sb-input {
  background-color: black !important;
  color: white !important;
}

</style>
